import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Search } from "MODULES/shared/components";
import { Pagination } from "MODULES/shared/components/Pagination";
import { USER } from "MODULES/users/constants";
import { pagination } from "./pagination";
import Table from "./Table";

function ReportsSearch() {
  return (
    <Search search={pagination} syncWithUrl>
      {searchProps => (
        <div>
          <div>
            <h2>Export Retrieval</h2>
          </div>
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

ReportsSearch.propTypes = {
  currentUser: T.instanceOf(Map),
  pushHistory: T.func.isRequired
};

export default connect(
  state => ({
    currentUser: state.session.get(USER)
  }),
  { pushHistory: push }
)(ReportsSearch);



// WEBPACK FOOTER //
// ./app/modules/Admin/Reports/Search.jsx